import * as classnames from 'classnames'
import * as React from 'react'

import { PlayState } from '@envato/react-video'

import * as styles from './clickOverlay.module.css'

const { PLAY } = PlayState

interface IProps {
  playState: PlayState
  onPlayVideo: () => any
  onPauseVideo: () => any
  hideCursor: boolean
}

const ClickOverlay = ({
  onPlayVideo,
  onPauseVideo,
  playState,
  hideCursor
}: IProps) => (
  <div className={styles.root}>
    <button
      className={
        hideCursor
          ? classnames(styles.hideCursor, styles.button)
          : styles.button
      }
      onClick={playState === PLAY ? onPauseVideo : onPlayVideo}
    />
  </div>
)

export default ClickOverlay
